// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

//全局定义Dialog弹框,Toast轻提示
import { Dialog, Toast, Loading, ImagePreview } from 'vant';

Vue.prototype.$dialog = Dialog
Vue.prototype.$toast = Toast
Vue.prototype.$loading = Loading
Vue.prototype.ImagePreview = ImagePreview
import { Lazyload } from 'vant';
Vue.use(Lazyload);

Vue.prototype.isShare = location.href.indexOf('share=1') > -1
import androidinfo from '@/utils/androidinfo'
try {
  let height = androidinfo.getStatusBarHeight();
  Vue.prototype.topHeight = height + 'px'
  Vue.prototype.topHeightNum = height
  Vue.prototype.pageHeight = (height+54)+'px'
} catch (error) {
  Vue.prototype.topHeight = Vue.prototype.isShare ? '0px' : '36px'
  Vue.prototype.topHeightNum = Vue.prototype.isShare ? 0 : 36
  Vue.prototype.pageHeight = Vue.prototype.isShare?'0px':'90px'
}

import "@/assets/css/vant.css"
import "@/assets/css/common.css"
import "@/components/package.js"
import 'lib-flexible/flexible.js'
import '@/utils/directiveFun.js'
import { getImageUrl, getAvatarUrl, getUserId, getToken, clearUserInfo, getShareUrl, clearCache, tabsClickScroll,showImg } from "@/utils/utils"
Vue.prototype.getImageUrl = getImageUrl
Vue.prototype.getAvatarUrl = getAvatarUrl
Vue.prototype.getUserId = getUserId
Vue.prototype.getToken = getToken
Vue.prototype.clearUserInfo = clearUserInfo
Vue.prototype.getShareUrl = getShareUrl
Vue.prototype.clearCache = clearCache
Vue.prototype.tabsClickScroll = tabsClickScroll
Vue.prototype.showImg = showImg

//全局变量
import global_app_intro from './assets/js/global_app_intro'
Vue.prototype.GLOBAL_APP_INTRO = global_app_intro

//日期格式转换
import format from './assets/js/format'
Date.prototype.format = format


import store from './store';
Vue.prototype.$store = store;

//版本管理
// const VUE_APP_VERSION = require('../package.json').version
// const vers = window.localStorage.getItem("Version");
// if(VUE_APP_VERSION != vers){
//   window.localStorage.setItem("Version", VUE_APP_VERSION);
//   location.reload()
// }

Vue.config.productionTip = false;

// 在创建 Vue 实例之前执行
(function() {
  const url = location.href;
  const isShare = url.indexOf('share=1') > -1;
  // 判断是否产品分享详情页
  if (isShare && url.indexOf('productDetail') > -1) {
    // 直接替换到列表页，并带跳转参数
    // window.location.replace(`/productCenter?fromShare=1&gotoId=${gotoId || ''}`);
    //window.location.replace(`#/productCenter?fromShare=1&id=0ece0a122149d5654d396cf87971b756&share=1`);
    // 整页跳转到列表页（这样会在历史栈中留下列表页）
   //  window.location.href = `#/productCenter?fromShare=1&id=0ece0a122149d5654d396cf87971b756&share=1`
    //history.pushState(null, '', '#/productCenter?fromShare=1&id=0ece0a122149d5654d396cf87971b756&share=1');
    // 找到问号的位置
    let idx = url.indexOf('?');
    // 如果有参数
    if (idx !== -1) {
      let queryString = url.substring(idx + 1); // 去掉 "?" 拿到后面
      // 如果不是德润厚天App，直接替换，否则会将德润厚天App的页面改变
      try {
        androidinfo.getAppVersionCode();
        // 通过原生桥接判断，是德润厚天App中的扫码则不替换
      } catch (e) {
        // 先跳转到列表页（强制插入历史记录）
        location.replace('#/productCenter?' + queryString);// 拼接到列表页
      }
    }
    // 再立刻跳回详情页
    // setTimeout(() => {
    //   // location.href = '#/productDetail?fromShare=1&id=0ece0a122149d5654d396cf87971b756&share=1';
    //   location.assign( '#/productDetail?fromShare=1&id=0ece0a122149d5654d396cf87971b756&share=1');
    // }, 200);
  }
})();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js